import React from 'react';

const HoverLogo = ({ ...props }) => (
  <svg
    width="116"
    height="33"
    viewBox="0 0 116 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M42.8441 15.557H34.5405V9.20145H32.4995V23.9588H34.5405V17.505H42.8441V23.9588H44.8851V9.20145H42.8441V15.557Z"
      fill="black"
    />
    <path
      d="M57.7772 8.99993C53.3645 8.99993 50.166 12.1881 50.166 16.5853C50.166 20.9825 53.3696 24.1655 57.7772 24.1655C62.1848 24.1655 65.3884 20.9773 65.3884 16.5853C65.3884 12.1932 62.1899 8.99993 57.7772 8.99993ZM61.6991 20.6415C60.7018 21.6387 59.3067 22.1865 57.7772 22.1865C56.2477 22.1865 54.8629 21.6387 53.8605 20.6415C52.8426 19.6236 52.2845 18.1819 52.2845 16.5853C52.2845 14.9886 52.8426 13.5418 53.8605 12.5291C54.8578 11.5318 56.2477 10.9841 57.7772 10.9841C59.3067 10.9841 60.7018 11.5318 61.6991 12.5291C62.717 13.5418 63.2802 14.9835 63.2802 16.5853C63.2802 18.1871 62.717 19.6236 61.6991 20.6415Z"
      fill="black"
    />
    <path
      d="M75.5983 21.6336L70.2245 9.20145H68.0439L74.384 23.8399L74.4305 23.9588H76.7299L83.1061 9.20145H80.9824L75.5983 21.6336Z"
      fill="black"
    />
    <path
      d="M89.2912 17.4947H96.8817V15.5674H89.2912V11.1391H98.2407V9.20145H87.2554V23.9588H98.3285V22.0211H89.2912V17.4947Z"
      fill="black"
    />
    <path
      d="M110.983 17.6394C112.833 17.3552 114.724 16.1409 114.724 13.4488C114.724 12.095 114.264 11.0358 113.355 10.2969C112.455 9.56832 111.164 9.20145 109.51 9.20145H103.682V23.9588H105.723V17.7066H108.704L113.148 23.9588H115.602L110.983 17.6394ZM105.723 15.8205V11.1391H109.489C111.567 11.1391 112.621 11.9142 112.621 13.4488C112.621 15.0248 111.567 15.8205 109.489 15.8205H105.723Z"
      fill="black"
    />
    <g clipPath="url(#clip0_874_1963)">
      <path
        d="M0.116211 13.0716V24.77L7.78423 20.9257V9.2221L0.116211 13.0716Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0269 12.2656L13.5301 0.5L3.9502 5.3106L15.4471 17.0762L15.4471 17.0762V28.7797L25.027 23.9691V12.2656L25.0269 12.2656Z"
        fill="black"
      />
      <path
        d="M11.613 27.7773L7.78418 26.7748V20.9257L11.613 21.9229V27.7773Z"
        fill="black"
      />
      <path
        d="M0.116211 13.0716V24.77L7.78423 20.9257V9.2221L0.116211 13.0716Z"
        fill="black"
      />
      <path
        d="M25.0269 12.2656L15.4471 17.0762L3.9502 5.3106L13.5301 0.5L25.0269 12.2656Z"
        fill="black"
      />
      <path
        d="M11.613 27.7773L7.78418 26.7748V20.9257L11.613 21.9229V27.7773Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_874_1963">
        <rect
          width="25.1429"
          height="32"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default HoverLogo;
